import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    pending: string;
    active: string;
    inactive: string;
    labelAdmin: string;
    labelGuest: string;
    labelMember: string;
    labelOwner: string;
    labelReviewer: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** User status: pending */
            pending: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GraphqlClient_AccountUserTypePolicy.pending?c=5dyipw40g6er", defaultMessage: "Pending" }));
                },
                enumerable: true,
                configurable: true
            },
            /** User status: active */
            active: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GraphqlClient_AccountUserTypePolicy.active?c=2095v17ylu8vo", defaultMessage: "Active" }));
                },
                enumerable: true,
                configurable: true
            },
            /** User status: inactive */
            inactive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GraphqlClient_AccountUserTypePolicy.inactive?c=35x00t5ixqcwu", defaultMessage: "Inactive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Account user type: admin */
            labelAdmin: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GraphqlClient_AccountUserTypePolicy.labelAdmin?c=1jp8z6lcsvipj", defaultMessage: "Content Admin" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Account user type: guest */
            labelGuest: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GraphqlClient_AccountUserTypePolicy.labelGuest?c=3dszhu21ezltw", defaultMessage: "Guest" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Account user type: member */
            labelMember: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GraphqlClient_AccountUserTypePolicy.labelMember?c=m9y5ixy73rk5", defaultMessage: "Member" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Account user type: owner */
            labelOwner: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GraphqlClient_AccountUserTypePolicy.labelOwner?c=q2yk8jehyit6", defaultMessage: "Owner" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Account user type: reviewer */
            labelReviewer: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GraphqlClient_AccountUserTypePolicy.labelReviewer?c=3uxmu9q03ucnw", defaultMessage: "Reviewer" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
